module.exports = __webpack_public_path__ + "Roboto-LightItalic.c7b4e746cf8ecbf412fc.woff";


//////////////////
// WEBPACK FOOTER
// /app/~/roboto-fontface/fonts/Roboto/Roboto-LightItalic.woff
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-LightItalic.woff
// module chunks = 16